var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    _vm._b({}, "v-card", _vm.computedCardProps, false),
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", color: "white", dense: _vm.toolbarDense } },
        [
          _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
          _c("v-spacer"),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _vm.searchBar
                ? _c("v-text-field", {
                    staticClass: "mt-6",
                    attrs: {
                      filled: "",
                      rounded: "",
                      dense: "",
                      "prepend-inner-icon": "mdi-magnify",
                      clearable: "",
                    },
                    model: {
                      value: _vm.computedSearchText,
                      callback: function ($$v) {
                        _vm.computedSearchText = $$v
                      },
                      expression: "computedSearchText",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._t(
            "add",
            function () {
              return [
                _vm.allowEdit
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", disabled: _vm.disabled },
                        on: { click: _vm.addItem },
                      },
                      [_c("v-icon", [_vm._v("add")])],
                      1
                    )
                  : _vm._e(),
              ]
            },
            {
              addItem: _vm.addItem,
              addItemMultiple: _vm.addItemMultiple,
              replaceItemMultiple: _vm.replaceItemMultiple,
            }
          ),
          _vm._t("append-top"),
        ],
        2
      ),
      _c(
        "v-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.modifiedHeaders,
              items: _vm.items,
              "item-key": "id",
              "show-expand": !_vm.noExpand,
              expanded: _vm.expandedItems,
              search: _vm.computedSearchText,
              dense: _vm.dense,
            },
            on: {
              "update:expanded": function ($event) {
                _vm.expandedItems = $event
              },
              change: _vm.saveItems,
              "current-items": _vm.setFilteredItems,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.name",
                  fn: function (props) {
                    return [
                      _c("v-text-field", {
                        attrs: {
                          label: "Name",
                          "single-line": "",
                          dense: _vm.dense,
                          "error-messages": _vm.$utils.getIfExists(
                            _vm.errorMessages,
                            ["name", "messages"]
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value: props.item.name,
                          callback: function ($$v) {
                            _vm.$set(props.item, "name", $$v)
                          },
                          expression: "props.item.name",
                        },
                      }),
                    ]
                  },
                },
                _vm._l(_vm.$slots, function (_, name) {
                  return {
                    key: name,
                    fn: function () {
                      return [_vm._t(name)]
                    },
                    proxy: true,
                  }
                }),
                _vm._l(_vm.$scopedSlots, function (_, scopedName) {
                  return {
                    key: scopedName,
                    fn: function (props) {
                      return [
                        _vm._t(
                          scopedName,
                          null,
                          {
                            allowEdit: _vm.allowEdit,
                            errors: _vm.$utils.getIfExists(_vm.errorMessages, [
                              _vm.items.indexOf(props.item),
                            ]),
                          },
                          props
                        ),
                      ]
                    },
                  }
                }),
                {
                  key: "item.actions",
                  fn: function (props) {
                    return [
                      _vm.copyBtn
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.copyItem(
                                                    _vm.items.indexOf(
                                                      props.item
                                                    )
                                                  )
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [_vm._v(" mdi-content-copy ")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Copy")])]
                          )
                        : _vm._e(),
                      _vm.allowEdit
                        ? _c(
                            "v-icon",
                            {
                              attrs: {
                                icon: "",
                                disabled: !_vm.allowEdit || props.item.noDelete,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.deleteItem(_vm.items.indexOf(props.item))
                                },
                              },
                            },
                            [_vm._v("delete ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                !_vm.noExpand
                  ? {
                      key: "expanded-item",
                      fn: function (ref) {
                        var item = ref.item
                        var headers = ref.headers
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "pa-1",
                              attrs: { colspan: headers.length },
                            },
                            [
                              _vm._t("default", null, {
                                item: item,
                                itemIndex: item.id,
                                errors: _vm.$utils.getIfExists(
                                  _vm.errorMessages,
                                  [_vm.items.indexOf(item)]
                                ),
                              }),
                            ],
                            2
                          ),
                        ]
                      },
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }